/* eslint-disable camelcase */
import { call, put, takeEvery } from 'redux-saga/effects';
import { fetchSaga } from '../../utils/network/fetch-saga';
import {
    getHeaders,
    getIdpBaseUrl,
    getPortalBaseUrl,
    trackUserEvent,
} from '../../utils/utils';

import { ERROR, GA } from '../../utils/constants';

import {
    FETCH_CHATS_REQUEST,
    fetchChatsSuccess,
    fetchConversationsSuccess,
    FETCH_CONVERSATIONS_REQUEST,
    SEND_QUESTION_REQUEST,
    createChatSuccess,
    fetchChatsFailure,
    SEND_CONVERSATION_QUESTION_REQUEST,
    createConversationQuestionSuccess,
    fetchConversationsFailure,
    createChatFailure,
    UPDATE_USER_ODH_POLICIES,
} from './actions';

import { addMessage } from '../../containers/MessageModal/actions';
import { setUser } from '../Account/actions';

export function* sendQuestionRequest(action) {
    const { request, intl } = action.payload;
    const { school_class, subject, conversation_topic, school_type } = request;
    const headers = getHeaders(true);

    try {
        const data = yield call(
            fetchSaga,
            `${getPortalBaseUrl()}/odh`,
            { method: 'POST', headers, body: JSON.stringify(request) },
        );

        if (data) {
            const { id, url } = data;

            trackUserEvent({
                trackUA: true,
                trackGA: false,
                category: GA.CATEGORIES.ODH,
                action: GA.ACTIONS.ODH_REQUEST,
                label: `class: "${school_class}", school subject: "${subject}", `
                + `type of school: "${school_type}"`,
                value: `question: "${conversation_topic}", id: ${id}, url: ${url}`,
            });
            yield put(createChatSuccess(data));
        } else {
            yield put(createChatFailure(true));
            yield put(addMessage(ERROR, intl.formatMessage({ id: 'homeworkHelp.request.error.500' })));
        }
    } catch (e) {
        yield put(createChatFailure(true));
        yield put(addMessage(ERROR, intl.formatMessage({ id: 'homeworkHelp.request.error.500' })));
    }
}

export function* getChats(action) {
    const { page, pageSize, userId, intl } = action.payload;
    const url = `${getPortalBaseUrl()}/odh/conversation/user/${userId}?page=${page}&pageSize=${pageSize}`;
    const headers = getHeaders(true);

    try {
        const data = yield call(fetchSaga, url, { method: 'GET', headers });
        if (data) {
            yield put(fetchChatsSuccess(data));
        } else {
            yield put(fetchChatsFailure(true));
        }
    } catch (e) {
        yield put(fetchChatsFailure(true));
        if (e.message.includes('Status 401')) {
            yield put(addMessage(ERROR, intl.formatMessage({ id: 'homeworkHelp.request.error.401' })));
        }
        if (e.message.includes('server error 500')) {
            yield put(addMessage(ERROR, intl.formatMessage({ id: 'homeworkHelp.request.error.500' })));
        }
    }
}

export function* getChatConversations(action) {
    const { id, intl } = action.payload;
    const url = `${getPortalBaseUrl()}/odh/chat/conversation/${id}`;
    const headers = getHeaders(true);
    try {
        const data = yield call(fetchSaga, url, { method: 'GET', headers });

        if (data) {
            yield put(fetchConversationsSuccess(id, data));
        }

    } catch (e) {
        yield put(fetchConversationsFailure(id, true));
        yield put(addMessage(ERROR, intl.formatMessage({ id: 'homeworkHelp.request.error.500' })));
    }
}

export function* sendConversationQuestionRequest(action) {
    const { request, intl } = action.payload;
    const { conversation_id, school_class, subject, conversation_topic, school_type } = request;
    const headers = getHeaders(true);
    try {
        const data = yield call(
            fetchSaga,
            `${getPortalBaseUrl()}/odh`,
            { method: 'POST', headers, body: JSON.stringify(request) },
        );

        if (data) {
            const { id, url } = data;
            trackUserEvent({
                trackUA: true,
                trackGA: false,
                category: GA.CATEGORIES.ODH,
                action: GA.ACTIONS.ODH_REQUEST,
                label: `class: "${school_class}", school subject: "${subject}", `
                + `type of school: "${school_type}"`,
                value: `question: "${conversation_topic}", id: ${id}, url: ${url}`,
            });
            yield put(createConversationQuestionSuccess(conversation_id, data));
        } else {
            yield put(addMessage(ERROR, intl.formatMessage({ id: 'homeworkHelp.request.error.500' })));
        }
    } catch (e) {
        yield put(addMessage(ERROR, intl.formatMessage({ id: 'homeworkHelp.request.error.500' })));
    }
}

export function* handleUpdateUserODHPoliecies(action) {
    const { userId, hasODHPoliciesAccepted } = action.payload;

    const baseUrl = getIdpBaseUrl();
    const url = `${baseUrl}/users/${userId}/odhPolicies?hasODHPoliciesAccepted=${hasODHPoliciesAccepted}`;
    const headers = getHeaders(true);

    try {
        const data = yield call(fetchSaga, url, { method: 'PUT', headers });
        if (data) {
            yield put(setUser(data));
        }
    } catch (e) {
        yield put(addMessage(ERROR, e.message));
    }
}

function* watchSendRequest() {
    yield takeEvery(SEND_QUESTION_REQUEST, sendQuestionRequest);
}

function* watchSendConversationQuestionRequest() {
    yield takeEvery(SEND_CONVERSATION_QUESTION_REQUEST, sendConversationQuestionRequest);
}

function* watchGetRequests() {
    yield takeEvery(FETCH_CHATS_REQUEST, getChats);
}

function* watchGetDetailedRequest() {
    yield takeEvery(FETCH_CONVERSATIONS_REQUEST, getChatConversations);
}

function* waitForUserODHPoliciesWasUpdated() {
    yield takeEvery(UPDATE_USER_ODH_POLICIES, handleUpdateUserODHPoliecies);
}

export const HomeworkHelpSaga = [
    watchSendRequest(),
    watchGetRequests(),
    watchGetDetailedRequest(),
    watchSendConversationQuestionRequest(),
    waitForUserODHPoliciesWasUpdated(),
];
